import { CheckCircle2, Rocket, Activity, Repeat, Lightbulb, Trophy, Award, TrendingUp, Smile, GraduationCap, X, Palette, Code, Gift } from "lucide-react";
import SEO from "../components/SEO";
import Button from "../components/Button";
import sponsorshipImage from "../assets/solutions/sponsorship.png";
import whiteLabelImage from "../assets/solutions/white-label.png";
import heroImage from "../assets/solutions/hero-image.png";

const Solutions = () => {
  return (
    <>
      <SEO
        title="Solutions for Business | Vespid - Financial Literacy Platform"
        description="Partner with Vespid to embed gamified financial literacy into your platform. Increase engagement, build trust, and create loyal customers with our proven education solutions."
        keywords="B2B financial literacy, financial education API, white label financial education, partner financial literacy, employee financial wellness, bank financial literacy"
        url="/solutions"
      />

      <div className="max-w-screen-xl lg:mx-auto font-primaryFont font-light text-gray-800 px-8">

        {/* Hero Section */}
        <section className="mt-10 md:mt-16 md:min-h-[70vh] flex flex-col md:flex-row md:justify-center md:items-center">
          {/* Illustration Placeholder */}
          <div className="flex justify-center md:w-1/3 mt-12 md:mt-0">
            <img
              src={heroImage}
              alt="Vespid holding a phone"
            />
          </div>

          <div className="md:pr-12 md:w-2/3 text-center md:text-left">
            <h1 className="font-bold text-4xl md:text-5xl lg:text-6xl leading-tight">
              Financial literacy that sticks.{" "}
              <span className="text-primaryYellow">Customers that stay.</span>
            </h1>
            <p className="text-xl md:text-2xl mt-8 text-gray-600 leading-relaxed">
              Embed Malaysia's leading gamified financial education platform into your app.
              Drive <span className="font-medium text-gray-800">3x higher engagement</span>,
              capture <span className="font-medium text-gray-800">behavioral insights</span>,
              and turn one-time users into loyal customers—all without building from scratch.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <Button
                href="https://form.typeform.com/to/QGaX0cpb"
                target="_blank"
                variant="primary"
                type="hero"
                size="lg"
              >
                Partner With Us
              </Button>
            </div>
            <div className="mt-8 flex flex-wrap gap-6 justify-center md:justify-start text-sm text-gray-500">
              <span className="flex items-center gap-2">
                <CheckCircle2 className="text-green-500" /> API & WebView Ready
              </span>
              <span className="flex items-center gap-2">
                <CheckCircle2 className="text-green-500" /> White-Label Available
              </span>
              <span className="flex items-center gap-2">
                <CheckCircle2 className="text-green-500" /> Launch in Weeks
              </span>
            </div>
          </div>


        </section>

        {/* Product Offerings Section */}
        {/* <section className="mt-24 md:mt-32">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold">Product Offerings</h2>
            <p className="text-xl text-gray-600 mt-4 max-w-2xl mx-auto">
              Choose the integration level that fits your business needs.
            </p>
          </div> */}

        {/* Feature Comparison Table */}
        {/* <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-900 text-white">
                  <th className="py-4 px-6 text-left font-semibold rounded-tl-xl">Features</th>
                  <th className="py-4 px-6 text-center font-semibold">
                    <div className="flex items-center justify-center gap-2">
                      <Gift className="w-5 h-5 text-primaryYellow" />
                      <span>Sponsorship</span>
                    </div>
                  </th>
                  <th className="py-4 px-6 text-center font-semibold">
                    <div className="flex items-center justify-center gap-2">
                      <Palette className="w-5 h-5 text-primaryYellow" />
                      <span>White Label</span>
                    </div>
                  </th>
                  <th className="py-4 px-6 text-center font-semibold rounded-tr-xl">
                    <div className="flex items-center justify-center gap-2">
                      <Code className="w-5 h-5 text-primaryYellow" />
                      <span>App Integration</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <FeatureRow feature="Brand awareness" sponsorship={true} whiteLabel={true} integration={true} />
                <FeatureRow feature="Content partnership" sponsorship={true} whiteLabel={true} integration={true} />
                <FeatureRow feature="Rewards partnership" sponsorship={true} whiteLabel={true} integration={true} />
                <FeatureRow feature="Theming" sponsorship={false} whiteLabel={true} integration={true} />
                <FeatureRow feature="Branding" sponsorship={false} whiteLabel={true} integration={true} />
                <FeatureRow feature="Content customization" sponsorship={false} whiteLabel={true} integration={true} />
                <FeatureRow feature="Localized community" sponsorship={false} whiteLabel={true} integration={true} />
                <FeatureRow feature="Embedding" sponsorship={false} whiteLabel={false} integration={true} isLast />
              </tbody>
            </table>
          </div>
        </section> */}

        {/* Individual Product Sections */}

        {/* Sponsorship Section */}
        <section className="mt-24 md:mt-32">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-2/3">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-primaryYellow rounded-full p-3">
                  <Gift className="w-6 h-6 text-black" />
                </div>
                <h3 className="text-3xl font-bold">Sponsorship</h3>
              </div>
              <p className="text-lg text-gray-600 leading-relaxed">
                The fastest way to get started. Sponsor financial literacy content and get your brand in front of engaged users learning about money. Perfect for partners looking to build trust and awareness without technical integration.
              </p>
              <ul className="mt-6 space-y-3">
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>Logo featured on Home screen</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>Sponsored content category with branding in flashcards and quizzes</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>Rewards curated for sponsors</span>
                </li>
              </ul>
            </div>
            <div className="md:w-1/3 flex justify-center">
              <img
                src={sponsorshipImage}
                alt="Sponsorship feature screenshot"
              />
            </div>
          </div>
        </section>

        {/* White Label Section */}
        <section className="mt-24 md:mt-32">
          <div className="flex flex-col md:flex-row-reverse items-center gap-12">
            <div className="md:w-2/3">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-black rounded-full p-3">
                  <Palette className="w-6 h-6 text-primaryYellow" />
                </div>
                <h3 className="text-3xl font-bold">White Label</h3>
              </div>
              <p className="text-lg text-gray-600 leading-relaxed">
                Make it yours. Our white-label solution lets you deploy Vespid's financial literacy platform under your own brand. Customize colors, logos, and content to create a seamless experience that feels native to your app.
              </p>
              <ul className="mt-6 space-y-3">
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>Full theming</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>Custom company logo and branding</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>Customized content categories and rewards</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>Partner-only leaderboard for localized community</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>User performance and engagement reporting</span>
                </li>
              </ul>
            </div>
            <div className="md:w-1/3 flex justify-center">
              <img
                src={whiteLabelImage}
                alt="White Label feature screenshot"
              />
            </div>
          </div>
        </section>

        {/* Integration Section */}
        <section className="mt-24 md:mt-32">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-2/3">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-primaryYellow rounded-full p-3">
                  <Code className="w-6 h-6 text-black" />
                </div>
                <h3 className="text-3xl font-bold">App Integration</h3>
              </div>
              <p className="text-lg text-gray-600 leading-relaxed">
                Deep integration for maximum control. Embed Vespid directly into your app with our WebView solution. Support for SSO, custom user flows, and seamless user experience. Ideal for fintechs and digital banks building comprehensive financial wellness features.
              </p>
              <ul className="mt-6 space-y-3">
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>All White Label features included</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>Embed directly in your mobile or web app</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>SSO for seamless user authentication</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>WebView integration with React Native & Cordova support</span>
                </li>
                <li className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" />
                  <span>User performance and engagement reporting</span>
                </li>
              </ul>
            </div>
            <div className="md:w-1/3 flex justify-center">
              {/* Phone Image Placeholder */}
              {/* <div className="w-64 h-[500px] bg-gradient-to-br from-yellow-100 to-yellow-50 rounded-[3rem] flex items-center justify-center border-4 border-gray-200 shadow-xl">
                <div className="text-center text-gray-400">
                  <Code className="w-12 h-12 mx-auto mb-3 text-primaryYellow" />
                  <p className="text-sm px-4">Integration Phone Screenshot</p>
                </div>
              </div> */}
            </div>
          </div>
        </section>

        {/* Why It Works Section */}
        <section className="mt-24 md:mt-32 mb-24">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold">Why It Works For Your Business</h2>
            <p className="text-xl text-gray-600 mt-4 max-w-2xl mx-auto">
              A win-win model that drives value for your business and your customers.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12 max-w-5xl mx-auto">

            {/* For Your Business */}
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-8 md:p-10 text-white shadow-2xl">
              <div className="flex items-center gap-3 mb-8">
                <div className="bg-primaryYellow rounded-full p-3">
                  <Activity className="w-6 h-6 text-black" />
                </div>
                <h3 className="text-2xl font-bold">For Your Business</h3>
              </div>

              <div className="space-y-6">
                <BenefitItem
                  icon={<TrendingUp className="w-5 h-5" />}
                  title="Trackable Funnel"
                  description="Monitor user journeys from first lesson to product adoption"
                  dark
                />
                <BenefitItem
                  icon={<Repeat className="w-5 h-5" />}
                  title="Repeatable Campaigns"
                  description="Launch targeted financial education campaigns in minutes"
                  dark
                />
                <BenefitItem
                  icon={<Award className="w-5 h-5" />}
                  title="Measurable Outcomes"
                  description="Prove ROI with learning completion and engagement metrics"
                  dark
                />
                <BenefitItem
                  icon={<Lightbulb className="w-5 h-5" />}
                  title="Behavioral Intelligence"
                  description="Understand customer financial interests before you sell"
                  dark
                />
                <BenefitItem
                  icon={<Rocket className="w-5 h-5" />}
                  title="Warmer Leads"
                  description="Educated customers convert better and stay longer"
                  dark
                />
              </div>
            </div>

            {/* For Consumers */}
            <div className="bg-gradient-to-br from-yellow-50 to-white rounded-3xl p-8 md:p-10 border-2 border-yellow-200 shadow-xl">
              <div className="flex items-center gap-3 mb-8">
                <div className="bg-black rounded-full p-3">
                  <Smile className="w-6 h-6 text-primaryYellow" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">For Consumers</h3>
              </div>

              <div className="space-y-6">
                <BenefitItem
                  icon={<Smile className="w-5 h-5" />}
                  title="Fun, Not Boring"
                  description="Gamified lessons that feel like play, not homework"
                />
                <BenefitItem
                  icon={<Trophy className="w-5 h-5" />}
                  title="Earn Real Rewards"
                  description="Points, streaks, and achievements that motivate"
                />
                <BenefitItem
                  icon={<TrendingUp className="w-5 h-5" />}
                  title="See Progress Clearly"
                  description="Visual learning paths and completion tracking"
                />
                <BenefitItem
                  icon={<GraduationCap className="w-5 h-5" />}
                  title="Actually Learn"
                  description="Bite-sized lessons backed by financial experts"
                />
                <BenefitItem
                  icon={<Lightbulb className="w-5 h-5" />}
                  title="Better Money Decisions"
                  description="Build confidence to take control of their finances"
                />
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-16">
            <Button
              href="https://form.typeform.com/to/QGaX0cpb"
              target="_blank"
              variant="primary"
              type="hero"
              size="lg"
            >
              Partner With Us
            </Button>
          </div>
        </section>

      </div>
    </>
  );
};

// Benefit Item Component
interface BenefitItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  dark?: boolean;
}

const BenefitItem = ({ icon, title, description, dark = false }: BenefitItemProps) => (
  <div className="flex gap-4">
    <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${dark ? 'bg-white/10 text-primaryYellow' : 'bg-primaryYellow/20 text-primaryYellow'
      }`}>
      {icon}
    </div>
    <div>
      <h4 className={`font-semibold ${dark ? 'text-white' : 'text-gray-800'}`}>{title}</h4>
      <p className={`text-sm mt-1 ${dark ? 'text-gray-300' : 'text-gray-600'}`}>{description}</p>
    </div>
  </div>
);

// Feature Row Component for Product Comparison Table (table currently commented out above)
interface FeatureRowProps {
  feature: string;
  sponsorship: boolean;
  whiteLabel: boolean;
  integration: boolean;
  isLast?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FeatureRow = ({ feature, sponsorship, whiteLabel, integration, isLast = false }: FeatureRowProps) => (
  <tr className={`border-b border-gray-200 ${!isLast ? '' : 'border-b-0'} hover:bg-gray-50 transition-colors`}>
    <td className={`py-4 px-6 text-gray-700 ${isLast ? 'rounded-bl-xl' : ''}`}>{feature}</td>
    <td className="py-4 px-6 text-center">
      {sponsorship ? (
        <CheckCircle2 className="w-6 h-6 text-green-500 mx-auto" />
      ) : (
        <X className="w-6 h-6 text-gray-300 mx-auto" />
      )}
    </td>
    <td className="py-4 px-6 text-center">
      {whiteLabel ? (
        <CheckCircle2 className="w-6 h-6 text-green-500 mx-auto" />
      ) : (
        <X className="w-6 h-6 text-gray-300 mx-auto" />
      )}
    </td>
    <td className={`py-4 px-6 text-center ${isLast ? 'rounded-br-xl' : ''}`}>
      {integration ? (
        <CheckCircle2 className="w-6 h-6 text-green-500 mx-auto" />
      ) : (
        <X className="w-6 h-6 text-gray-300 mx-auto" />
      )}
    </td>
  </tr>
);

export default Solutions;
